import { render } from "./ArrowLeftIcon.vue?vue&type=template&id=67230c48"
import script from "./ArrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./ArrowLeftIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__